import { gsap } from 'gsap';
import scrollToRightSide from './scrollToRightSide';

export default function () {
  const focusContainer = document.querySelector('[data-horizontal-scroll]');

  function isElementVisible(element) {
    const rect = element.getBoundingClientRect();
    return rect.left >= 0 && rect.right <= window.innerWidth;
  }

  if (focusContainer) {
    focusContainer.addEventListener('focus', (event) => {
      const { target } = event;
      const isChildOfFocusContainer = focusContainer.contains(target);

      if (isChildOfFocusContainer) {
        const isVisible = isElementVisible(target);

        if (!isVisible) {
          scrollToRightSide(target);
          setTimeout(() => {
            gsap.to(target, {});
          }, 500);
        }
      }
    }, true);
  }
}
